const ACCESS_TOKEN_KEY = 'myslikrok.admin.accessToken';
const REFRESH_TOKEN_KEY = 'myslikrok.admin.refreshToken';

export const readAccessToken = (): string | null => {
  try {
    return window.localStorage.getItem(ACCESS_TOKEN_KEY);
  } catch {
    return null;
  }
};

export const readRefreshToken = (): string | null => {
  try {
    return window.localStorage.getItem(REFRESH_TOKEN_KEY);
  } catch {
    return null;
  }
};

export const writeTokens = (accessToken: string, refreshToken: string): void => {
  try {
    window.localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    window.localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  } catch {
    // A browser with site data blocked simply signs the operator out on reload.
  }
};

export const clearTokens = (): void => {
  try {
    window.localStorage.removeItem(ACCESS_TOKEN_KEY);
    window.localStorage.removeItem(REFRESH_TOKEN_KEY);
  } catch {
    // Nothing to clear.
  }
};
